import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    user: {},
    users: [],
    approvalGroups: [],
    approvalProcesses: [],                  // 사용위치 : ServiceCode
    approvalProcess: {},
    approvalProcessesAfter: [],                  // 사용위치 : ServiceCode
    approvalProcessAfter: {},
    code: {},                               // 사용위치 : ServiceApply, ServiceRequest, rentalAssetView
    sequencingCodeName: "",
    content: {},
    contentApproval: {},
    statusNumericValue: 0,
    progressStatusValue: {
        contentCategory: "",
        contentId: 0,
        linkedId: 0,
        rejected: "",
        statusKorValue: "",
        statusNumericValue: 0,
    },
    selectedUser: {
        requester: {}, applier: {}, handler: {}, user: {},
    },
    selectedUsers: {
        requesters: [], appliers: [], handlers: [], users: [],
    }
}

const contentSlice = createSlice({
    name: "content",
    initialState,
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload;
        },
        setUsers: (state, action) => {
            state.users = action.payload;
        },
        setApprovalGroups: (state, action) => {
            state.approvalGroups = action.payload;
        },
        setApprovalProcesses: (state, action) => {
            state.approvalProcesses = action.payload;
            const value = state.approvalProcesses;
            if (Array.isArray(value) && value.length > 0) {
                state.approvalProcess = value[0];
            } else {
                state.approvalProcess = {};
            }
        },
        setApprovalProcessesAfter: (state, action) => {
            state.approvalProcessesAfter = action.payload;
            const value = state.approvalProcessesAfter;
            if (Array.isArray(value) && value.length > 0) {
                state.approvalProcessAfter = value[0];
            } else {
                state.approvalProcessAfter = {};
            }
        },
        setApprovalProcess: (state, action) => { state.approvalProcess = action.payload },
        setApprovalProcessAfter: (state, action) => { state.approvalProcessAfter = action.payload },
        setSequencingCodeName: (state, action) => { state.sequencingCodeName = action.payload; },
        setCode: (state, action) => { state.code = action.payload; },
        setContent: (state, action) => { state.content = action.payload; },
        changeStatusNumericValue: (state, action) => { state.statusNumericValue = action.payload; },
        changeProgressStatusValue: (state, action) => {state.progressStatusValue = action.payload},
        setRequesters: (state, action) => {
            state.selectedUsers = { ...state.selectedUsers, requesters: action.payload };
            const value = state.selectedUsers.requesters;
            if (Array.isArray(value) && value.length > 0) {
                state.selectedUser.requester = value[0];
            }
        },
        setAppliers: (state, action) => {
            state.selectedUsers = { ...state.selectedUsers, appliers: action.payload };
            const value = state.selectedUsers.appliers;
            if (Array.isArray(value) && value.length > 0) {
                state.selectedUser.applier = value[0];
            }
        },
        setHandlers: (state, action) => {
            state.selectedUsers = { ...state.selectedUsers, handlers: action.payload };
            const value = state.selectedUsers.handlers;
            if (Array.isArray(value) && value.length > 0) {
                state.selectedUser.handler = value[0];
            }
        },
        setSelectedUsers: (state, action) => {
            state.selectedUsers = { ...state.selectedUsers, users: action.payload };
            const value = state.selectedUsers.users;
            if (Array.isArray(value) && value.length > 0) {
                state.selectedUser.user = value[0];
            }
        },
        putContentApproval: (state, action) => { state.contentApproval = action.payload; },
        resetContents: (state, action) => { Object.assign(state, initialState); },
        resetApprovalProcesses: (state, action) => { state.approvalProcesses = []; },
        resetApprovalProcessesAfter: (state, action) => { state.approvalProcessesAfter = []; },
        resetProgressStatusValue: (state, action) => { state.progressStatusValue = initialState.progressStatusValue },
        removeUser: (state, action) => {
            state.selectedUser[action.payload] = {};
        }
    }
});

export const {
    setUser,
    setUsers,
    setApprovalGroups,
    setApprovalProcesses,
    setApprovalProcess,
    setApprovalProcessesAfter,
    setApprovalProcessAfter,
    setCode,
    setSequencingCodeName,
    setContent,
    changeStatusNumericValue,
    changeProgressStatusValue,
    setRequesters,
    setAppliers,
    setHandlers,
    setSelectedUsers,
    putContentApproval,
    resetContents,
    resetApprovalProcesses,
    resetApprovalProcessesAfter,
    resetProgressStatusValue,
    removeUser
} = contentSlice.actions;
export default contentSlice.reducer;